import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ThirdPartyJobPaymentsAdminSearchParams from './ThirdPartyJobPaymentsAdminSearchParams';

export default class TpJobEvaluatorPaymentsTabSearchParams extends ThirdPartyJobPaymentsAdminSearchParams {
  static fieldsInSearchBox = [
    { fieldName: 'TpEvaluatorTpJobPaymentId', label: 'Pay ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorNameOrId', label: 'Evaluator Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'TpEvaluatorEmail', label: 'Evaluator Email', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedTpJobCountryCodes',
      label: 'Country',
      className: 'col-6',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedPaymentOffices',
      label: 'Payment Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'ProjectNameOrId', label: 'Project Name or ID', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'TypeText',
      label: 'Type',
      className: 'col-2',
      type: InputTypesEnum.MultiChoice,
      options: ThirdPartyJobPaymentsAdminSearchParams.getTypeTextSelectOptions(),
    },
    {
      fieldName: 'StatusCodeLookupValue',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 45,
    },
    { fieldName: 'EmptyPayment', label: 'Empty Payment', className: 'col-2', type: InputTypesEnum.EmptyYesNoSelect },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-6', type: InputTypesEnum.UserSelect },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-6', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'SelectedThirdPartyJobStatuses',
      label: 'Third-Party Job Status',
      className: 'col-4',
      type: InputTypesEnum.TpJobStatusMultiSelect,
    },
    {
      fieldName: 'HasExportPayment',
      label: 'Has Export Payment',
      className: 'col-2',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];
}
